import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class CourseAttachmentRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    return true;
  }
}